function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M180-264q-15.3 0-25.65-10.29Q144-284.58 144-299.79t10.35-25.71Q164.7-336 180-336h168q15.3 0 25.65 10.29Q384-315.42 384-300.21t-10.35 25.71Q363.3-264 348-264H180Zm.29-180q-15.29 0-25.79-10.29t-10.5-25.5q0-15.21 10.34-25.71t25.63-10.5h359.74q15.29 0 25.79 10.29t10.5 25.5q0 15.21-10.34 25.71T540.03-444H180.29ZM180-624q-15.3 0-25.65-10.29Q144-644.58 144-659.79t10.35-25.71Q164.7-696 180-696h600q15.3 0 25.65 10.29Q816-675.42 816-660.21t-10.35 25.71Q795.3-624 780-624H180Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#DDDDDD"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/sort.8d2a4c4d.svg";
export { SvgComponent as ReactComponent };